const { dataLayerListener } = require('./data-layer.cjs');
const { getGTMId, gtm } = require('./gtm.cjs');
const { alfaPartners } = require('./partners.cjs');
const { platformIdReady } = require('./platform-id-ready.cjs');
const { ytm, ytmCookie, ytmNoScript, ytmSendEvent, ytmSendUserParams } = require('./ytm.cjs');
const { utmForwardingPages } = require('./ym-config.cjs');
const { utmTags } = require('./utm-tags.cjs');

const getCounters = (url, data) => {
    const { CUSTOM_YTM_ID, ENABLE_COUNTERS } = process.env;
    const {
        collectorData: { host }
    } = data;
    const gtmId = getGTMId(host);
    const isCountersEnabled = ENABLE_COUNTERS === 'true';
    const enableYtm = isCountersEnabled && CUSTOM_YTM_ID;
    const ytmScripts = [ytmNoScript, ytmCookie, dataLayerListener, ytmSendUserParams, ytmSendEvent];
    const headGTM = isCountersEnabled ? gtm(gtmId) : '';
    const headYTM = enableYtm ? ytm(url) : '';
    const bodyYTM = enableYtm ? ytmScripts.join('') : '';

    return {
        headCounters: [platformIdReady, headGTM, headYTM],
        bodyCounters: [bodyYTM, isCountersEnabled ? alfaPartners(url) : ''],
        endBodyCounters: [utmForwardingPages.some(page => url.includes(page)) ? utmTags : '']
    };
};

module.exports = {
    getCounters
};
